import React from 'react'
import { useSelector } from 'react-redux'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

function Fasce({maxEuroArray}) {
    let fasce = useSelector((user) => user.dataMonth.fasce)
    fasce = fasce && fasce.map((r) => { return parseFloat(r) })
    return (
        <div className="month_fasce">
            <p className="month_fasce-title">Consumi per fasce</p>
            <p className="month_fasce-secondary">
                Controlla quanto consumi per fascia oraria. Vuoi saperne di più? Clicca in basso!
            </p>
            {/* <div className="month_fasce-moreInfo">
                <p>Scopri di più sulle fasce</p>
                <ArrowForwardIosIcon />
            </div> */}
            <div className="month_fasce-table">
                {fasce && fasce.map((r, i) => (
                    <div key={i} className="month_fasce-table_f">
                        <div className="icon" style={i === 0 ? { backgroundColor: '#DCDCDC' } : i === 1 ? { backgroundColor: '#B2B3B4' } : { backgroundColor: '#697386' }}></div>
                        <div className="type">{i === 0 ? 'F1' : i === 1 ? 'F2' : 'F3'}</div>
                        <div className="consumo"><span className="bold">{parseFloat(r).toFixed(2).replace(/\./g, ",")}</span> kWh</div>
                        {/* <div className="price"><span className="bold">80</span> €</div> */}
                    </div>
                ))}
                <div className="month_fasce-table_bar">
                    {fasce && fasce.map((r, i) => (
                        <div className={`bar ${i === 0 ? 'f1' : i === 1 ? 'f2' : 'f3'}`} style={{ width: `${parseFloat(r) / 3 * 100}%` }}></div>
                    ))}
                </div>
                <div className="month_fasce-table_review">
                    <div className="label">Totale</div>
                    <div className="main"><span className="bold">{fasce && fasce.reduce((a, b) => a + b).toFixed(2).replace(/\./g, ",")}</span> kWh</div>
                    <div className="main"><span className="bold">{maxEuroArray && maxEuroArray.reduce((a, b) => a + b).toFixed(2).replace(/\./g, ",")}</span> €</div>
                </div>
            </div>
        </div>
    )
}

export default Fasce